// extracted by mini-css-extract-plugin
export default {"innerContainer":"zANl2n","textContainer":"bXNm0M","button":"mgB8PG","pricePerDay":"G_UGwS"};